import { Controller } from "@hotwired/stimulus";

// Disables file attachments for Trix editors inside this element: rejects
// drops/pastes and hides the toolbar attach button.
export default class extends Controller {
  connect() {
    this.rejectFile = (event) => event.preventDefault();
    this.hideAttachButton = (event) => {
      const button = event.target.toolbarElement?.querySelector(
        "[data-trix-button-group='file-tools']",
      );
      if (button) button.style.display = "none";
    };
    this.element.addEventListener("trix-file-accept", this.rejectFile);
    this.element.addEventListener("trix-initialize", this.hideAttachButton);
    // Editor may already be initialized when we connect (e.g. Turbo restore)
    const editors = this.element.matches("trix-editor")
      ? [this.element]
      : this.element.querySelectorAll("trix-editor");
    editors.forEach((editor) => {
      const group = editor.toolbarElement?.querySelector(
        "[data-trix-button-group='file-tools']",
      );
      if (group) group.style.display = "none";
    });
  }

  disconnect() {
    this.element.removeEventListener("trix-file-accept", this.rejectFile);
    this.element.removeEventListener("trix-initialize", this.hideAttachButton);
  }
}
